<template>
  <v-dialog v-model="dialog" max-width="1200px">
    <v-card>
      <v-card-title class="mx-3">
        <span
          v-if="value"
          class="d-inline-block text-truncate"
        >
          {{ $t("OrdersPricing.title") }}
        </span>
        <span
          class="red--text d-inline-block text-truncate"
        >
            {{
              $t("Material.materialNameWithCode", [
                currentItem.material_code,
                currentItem.material_name
              ])
            }}
        </span>
        <span class="red--text d-inline-block text-truncate">[
          <span v-if="currentItem.standard_name && currentItem.standard_name.length > 12" :title="currentItem.standard_name" style="cursor: pointer">
            {{ currentItem.standard_name.slice(0, 12) + "......" }}
          </span>
          <span v-else>
            {{ currentItem.standard_name }}
          </span>]
        </span>
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false"
              >fa-times
            </v-icon>
          </template>
          <span>
            {{ $t("$vuetify.close") }}
          </span>
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-container v-if="value">
          <v-data-table
            :headers="orderHeaders"
            :items="orders"
            dense
            multi-sort
            disable-pagination
            hide-default-footer
            fixed-header
          >
            <template v-slot:header.order_detail.price="{ header }">
              <v-text-field
                v-model="batchPrice"
                single-line
                dense
                hide-details
                type="number"
                style="max-width: 150px; font-weight:normal"
                :placeholder="$t('OrdersPricing.batchPricing')"
              >
                <template v-slot:prepend>
                  <span class="caption" style="min-width: 30px">{{ header.text }}</span>
                </template>
                <template v-slot:append>
                  <v-icon
                    x-small
                    @click.stop="batchPricing()"
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-check
                  </v-icon>
                </template>
              </v-text-field>
            </template>
            <template v-slot:item.order_detail.price="{ item }">
              <v-text-field
                v-model="item.order_detail.price"
                single-line
                dense
                hide-details
                type="number"
                style="max-width: 150px"
              >
                <template v-slot:append>
                  <v-icon
                    x-small
                    @click.stop="pricing(item)"
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-check
                  </v-icon>
                </template>
              </v-text-field>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="primary"
          @click="batchPricing('batchSave')"
        >
          {{$t("CRUD.save") }}
        </v-btn>
      </v-card-actions>
<!--      <v-card-actions>-->
<!--        <v-spacer></v-spacer>-->
<!--        <v-btn color="accent" @click="Save()">{{ $t("CRUD.confirm") }}</v-btn>-->
<!--      </v-card-actions>-->
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Orders from "@/api/orders";

export default {
  name: "OrderListsDialog",

  props: {
    value: Boolean,
    searcherData: Object,
    currentItem: Object,
  },

  computed: {
    orderHeaders() {
      return [
        {
          text: i18n.t("OrdersPricing.Fields.order_code"),
          align: "start",
          sortable: false,
          value: "order_code",
        },
        {
          text: i18n.t('OrdersPricing.Fields.shop_name', [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop.shop_name",
        },
        {
          text: i18n.t("OrdersPricing.Fields.fix_num"),
          align: "start",
          sortable: false,
          value: "order_detail.fix_num",
        },
        {
          text: i18n.t("OrdersPricing.Fields.stock_name"),
          align: "start",
          sortable: false,
          value: "stock_order.stock.name"
        },
        {
          text:i18n.t("OrdersPricing.Fields.price"),
          align: "start",
          sortable: false,
          width: 200,
          value: "order_detail.price"
        }
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    orders: [],
    batchPrice: "",
  }),

  methods: {
    getPricingOrders() {
      this.$store.dispatch("fullscreenLoading");
      Orders.getPricingOrders(Object.assign({}, this.searcherData, {
        material_ids: [this.currentItem.material_id]
      })).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.orders = response.data.orders
            this.$store.dispatch("fullscreenLoadingStop");
          }else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      )
    },
    pricing(data) {
      if (data.order_detail.price == ''){
        this.$snackbar.error(i18n.t("OrdersPricing.Messages.noPrice"));
        return
      }
      this.$store.dispatch("fullscreenLoading");
      let postData = {
        id: data.id,
        order_code: data.order_code,
        order_detail: {
          id: data.order_detail.id,
          material_id: data.order_detail.material_id,
          material_code: data.order_detail.material_code,
          price: data.order_detail.price
        }
      }
      if (this.searcherData.is_template_edit.length > 0) {
        postData.is_template_edit = 1
      }
      Orders.orderPricing(postData).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getPricingOrders()
            this.$snackbar.success(i18n.t("OrdersPricing.Messages.pricingSuccess"));
            this.$store.dispatch("fullscreenLoadingStop");
          }else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      )
    },
    async batchPricing(type = 'pricing')
    {
      if (this.batchPrice == '' && type == 'pricing'){
        this.$snackbar.error(i18n.t("OrdersPricing.Messages.noPrice"));
        return
      }
      this.$store.dispatch("fullscreenLoading");
      let successCount = 0;
      let errorCount = 0;

      for (let i = 0; i < this.orders.length; i++) {
        if (type == 'pricing') {
          let postData = {
            id: this.orders[i].id,
            order_code: this.orders[i].order_code,
            order_detail: {
              id: this.orders[i].order_detail.id,
              material_id: this.orders[i].order_detail.material_id,
              material_code: this.orders[i].order_detail.material_code,
              price: this.batchPrice
            }
          }
          if ((this.searcherData.is_template_edit.length > 0) && i == (this.orders.length - 1)) {
            postData.is_template_edit = 1
          }
          let response = await Orders.orderPricing(postData)
          if (response.data.status.isOK()) {
            successCount ++;
          }else {
            errorCount ++;
          }
        }else if (type == 'batchSave') {
          if (this.orders[i].order_detail.price) {
            let postData = {
              id: this.orders[i].id,
              order_code: this.orders[i].order_code,
              order_detail: {
                id: this.orders[i].order_detail.id,
                material_id: this.orders[i].order_detail.material_id,
                material_code: this.orders[i].order_detail.material_code,
                price: this.orders[i].order_detail.price
              }
            }
            if ((this.searcherData.is_template_edit.length > 0) && i == (this.orders.length - 1)) {
              postData.is_template_edit = 1
            }
            let response = await Orders.orderPricing(postData)
            if (response.data.status.isOK()) {
              successCount ++;
            }else {
              errorCount ++;
            }
          }else {
            errorCount ++;
          }
        }
      }
      this.$snackbar.info(i18n.t("OrdersPricing.Messages.batchInfo", [successCount, errorCount]));
      this.$store.dispatch("fullscreenLoadingStop");
      this.getPricingOrders()
    }
  },

  watch: {
    dialog: {
      handler() {
        if (!this.dialog) this.$emit("input", null);
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = true;
          this.getPricingOrders()
        }else {
          this.orders = [];
          this.batchPrice = ""
        }
      },
    },
  },
};
</script>